import moment from "moment";
import React, {useEffect, useState} from "react";
import {EventBriteFetcher} from "../EventBriteHelper";
import {EventIntf} from "../ServerTypes";
import {Button} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import CreateEventVenueSelection from "./CreateEventVenueSelection";

interface OrgObj {
    name: string
    id: string
}

export interface EventObj {
    name: string
    description: string
    id: string
    start: string
    end: string
    timeZone: string
    organization_id: string
}

class EventDisplay {
    constructor(public ebEvent: EventObj, public serverEvent: EventIntf | null) {
    }
}

const ebFetcher = new EventBriteFetcher()

export default function CreatEventFromEventBrite() {
    const [eventDetails, setEventDetails] = useState<EventDisplay[]>([])
    const [ebEventToCreate, setEbEventToCreate] = useState<EventObj | null>(null)

    useEffect(() => {
        loadEventData().then((eventDetails) => setEventDetails(eventDetails))
    }, [])


    const history = useHistory()

    const loadEventData = async () => {
        let json = await ebFetcher.fetch("https://www.eventbriteapi.com/v3/users/me/organizations/")
            .then(response => response.json());
        const orgs = json.organizations.map((org: any) => {
            return {
                name: org.name,
                id: org.id
            }
        }) as EventObj[]

        let eventCollection: EventObj[] = []

        for (const org of orgs) {
            const json = await ebFetcher.fetch(`https://www.eventbriteapi.com/v3/organizations/${org.id}/events/`)
                .then(response => response.json())

            console.log("json", json)
            const eventObs = json.events.map((ev: any) => {
                const name: string = ev.name.text
                const description: string = ev.description.text
                const id: string = ev.id
                const start: string = ev.start.local
                const end: string = ev.end.local
                const timeZone: string = ev.start.timezone
                const organization_id: string = ev.organization_id

                return {
                    name: name,
                    description: description,
                    id: id,
                    start: start,
                    end: end,
                    timeZone: timeZone,
                    organization_id: organization_id
                }
            }).filter((ev: EventObj) => moment(ev.end).isAfter(moment()))

            eventObs.forEach((ev: EventObj) => eventCollection.push(ev))
        }

        const futureEventsJson = await fetch(`${process.env.REACT_APP_API_CALL}/get-future-events`, {
            credentials: 'include'
        }).then(response => response.json())

        const eventDisplayCollection = eventCollection.map((eventObj) => {
            const serverEvent = futureEventsJson.find((serverEvent: EventIntf) => serverEvent.eventbrite_id === eventObj.id)
            return new EventDisplay(eventObj, serverEvent ? serverEvent : null)
        })

        console.log("eventDisplayCollection", eventDisplayCollection)

        return eventDisplayCollection
    }

    const showEvent = (id: number) => history.push(`/admin/event/${id}`)

    return <>
        {ebEventToCreate ?
            <CreateEventVenueSelection ebEvent={ebEventToCreate}/>
            :
            <ul>
                {eventDetails.map((ev) => (
                        <li key={ev.ebEvent.id}>{ev.ebEvent.name} <Button
                            onClick={() => ev.serverEvent ? showEvent(ev.serverEvent.id) : setEbEventToCreate(ev.ebEvent)}>{ev.serverEvent ? "Edit" : "Create"}</Button>
                        </li>
                    )
                )}
            </ul>
        }

    </>
}
